var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 6H21","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 12H21","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3 18H21","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
